import { useContext, useMemo } from "react";
import { UserContext } from "contexts/UserContext/UserContext";
import { IEventReportDetails } from "entities/EventReports/EventReportsEntityInterfaces";
import { OPERATOR_EXCEPTIONS } from "constants/constants";
import { DetailsReportEditionContext } from "contexts/DetailsReportEditionContext/DetailsReportEditionContext";
import { OperatorField } from "../SegmentFields";

/**
 * Inline-edit adapter: binds the controlled OperatorField to the
 * DetailsReportEditionContext for the table's row edit.
 */
export const OperatorDropdown = ({ row }: { row: IEventReportDetails }) => {
    const { user_id } = useContext(UserContext);
    const { edit, setEdit } = useContext(DetailsReportEditionContext);

    const existingEdition = useMemo(() => edit.findIndex((event) => event.id === row.event_report_id), [edit, row]);
    const selectedOperatorId = useMemo(
        () =>
            edit[existingEdition]?.changes?.user_id === row?.user_operator?.user_id &&
            row?.user_operator?.code === OPERATOR_EXCEPTIONS.NO_OPERATOR
                ? undefined
                : edit[existingEdition]?.changes?.user_id,
        [edit, existingEdition, row],
    );

    const handleOperatorUpdate = (id: number) => {
        if (existingEdition === -1) return;
        setEdit((prevEdit) => {
            const newEdit = [...prevEdit];
            newEdit[existingEdition] = {
                ...newEdit[existingEdition],
                changes: {
                    ...newEdit[existingEdition]?.changes,
                    user_id: id,
                    ...(user_id && { edited_by_user_id: user_id }),
                },
            };
            return newEdit;
        });
    };

    return (
        <OperatorField
            machineCenterId={row.machine_center.machine_center_id}
            clusterId={row.cluster_id}
            value={selectedOperatorId}
            onChange={handleOperatorUpdate}
        />
    );
};
